export const AnalyticsHubConstants = {
  analyticsHub: {
    title: "Your Complete Cricket Analytic Hub",
    description:
      "Powerful insights for players, teams, coaches, and associations.From live data to AI-driven analysis, everything cricket in one place.",
    stats: [
      {
        value: "15,000+",
        label: "Active Players",
        color: "light-blue",
      },
      {
        value: "100+",
        label: "Cricket Leagues",
        color: "light-blue",
      },
      {
        value: "3,000+",
        label: "Matches Scored",
        color: "light-purple",
      },
    ],
  },
};
